import { Box, Container, Typography } from "@mui/material";
import React from "react";
import {
  colorApp,
  colorBg,
  colorBlack,
  smTitleStyle,
  textStyle,
  titleStyle,
} from "../../../Resources/Design/theme";

import qr from "./qr.png";
import FadeIn from "../../../Components/FadeIn";

export default function CoopSupport() {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: colorApp,
        mt: { xs: "60px", sm: "90px", md: "90px" },
        pt: { xs: "60px", sm: "90px", md: "60px" },
        pb: { xs: "0px", sm: "0px", md: "60px" },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          overflowX: { xs: "hidden", sm: "hidden", md: "visible" },
        }}
        id="support"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", sm: "100%", md: "50%" },
          }}
        >
          <Typography
            sx={{
              ...smTitleStyle,
              color: colorBg,
              textAlign: "left",
              //pt: "60px",
            }}
          >
            Spolupráce
          </Typography>
          <Typography
            sx={{
              ...titleStyle,
              color: colorBg,
              textAlign: "left",
              mt: "14px",
            }}
          >
            Máte zájem o spolupráci?
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              color: colorBg,
              textAlign: "left",
              mt: "14px",
              maxWidth: { xs: "100%", sm: "100%", md: "400px" },
              mr: "32px",
            }}
          >
            Jsme vřele otevřeni jakékoliv spolupráci s kýmkoliv kdo má chuť
            předat zajímavé informace nebo vlastní příběhy z oblasti kynologie.
            Bereme to jako jeden ze základních stavebních kamenů projektu. Máte
            něco, co si zaslouží být vidět? Neváhejte nás kontaktovat! Všechny
            údaje najdete v sekci Kontakty.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            bgcolor: colorBg,
            mt: { xs: "60px", sm: "90px", md: "-120px" },
            mb: { xs: "0px", sm: "0px", md: "-120px" },
            py: { xs: "60px", sm: "90px", md: "120px" },

            minHeight: "100%",
            px: { xs: "16px", sm: "24px", md: "40px" },
            mx: { xs: "-16px", sm: "-24px", md: "0px" },
            width: { xs: "100vw", sm: "100vw", md: "50%" },
          }}
        >
          <Typography
            sx={{
              ...smTitleStyle,
              color: colorApp,
              textAlign: "left",
              //pt: "60px",
            }}
          >
            Podpora
          </Typography>
          <Typography
            sx={{
              ...titleStyle,
              color: colorApp,
              textAlign: "left",
              mt: "14px",
            }}
          >
            Chcete nás podpořit?
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              color: colorBlack,
              textAlign: "left",
              mt: "14px",
            }}
          >
            Projekt S Čumákem Na Stopě nemá primární cíl být výdělečný, avšak -
            jako vše - to stojí peníze. Peníze použijeme výhradně na účely
            projektu
          </Typography>
          <FadeIn>
            <Box
              component="img"
              src={qr}
              sx={{
                width: "180px",
                height: "180px",
                my: "32px",
                mx: "auto",
              }}
            />
          </FadeIn>

          <Typography
            sx={{
              ...textStyle,
              color: colorBlack,
              textAlign: "left",
              ml: "16px",
            }}
          >
            Použijte náš QR kód a nezapomeňte uvést v popisku své jméno a
            příjmení, nebo přezdívku. A pamatuj, každý čtvrťák nám udělá velkou
            radost!
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
